/**
 * Standard storage keys owned by the trimble-identity library
 * These keys are used internally by the library for session management
 */
export const StandardStorageKeys: Record<string, string[]> = {
  /**
   * Access token key
   */
  TC_ACCESS_TOKEN: ['tc-access-token'],

  /**
   * Session storage key for production environment
   */
  TRIMBLE_SERVICES: ['trimble-services'],

  /**
   * Session storage key for stage environment
   */
  TRIMBLE_SERVICES_STAGE: ['trimble-services-stage'],

  /**
   * Code verifier for PKCE (current)
   */
  CODE_VERIFIER: ['CODE_VERIFIER'],

  /**
   * Code verifier for PKCE (next, used for rotation)
   */
  NEXT_CODE_VERIFIER: ['NEXT_CODE_VERIFIER'],

  /**
   * Flag indicating token refresh is in progress
   */
  IS_TOKEN_REFRESH_IN_PROGRESS: ['is-token-refresh-in-progress'],
};

/**
 * Get the appropriate session key based on environment
 * @param isStage Whether the environment is stage
 * @returns The session key array
 */
export function getSessionStorageKey(isStage: boolean): string[] {
  return isStage
    ? StandardStorageKeys['TRIMBLE_SERVICES_STAGE']
    : StandardStorageKeys['TRIMBLE_SERVICES'];
}
